


























import { Vue, Component, Prop } from 'vue-property-decorator';
import {
    AddOrUpdateCartItem,
    OrderRow,
    ProductPriceStockRequest,
    JeevesPriceRequest,
    JeevesPriceItem
} from '@/models/Cart/Cart';
import { CheckoutStore } from '@/store/checkoutstate';
import { Spinner } from 'spin.js';
import { htmlDecode } from '@/mixins/html';

@Component
export default class BuyButtonContainer extends Vue {
    public quantity: number;
    protected spinner: Spinner;
    protected articleNumber!: string;
    protected showPrice!: boolean;
    protected price!: string;
    protected deliveryInfo!: string;
    protected description!: string;
    protected rowSystemId!: string;
    protected cssClass!: string;
    protected redirectUrl!: string;
    protected showQuantityField: boolean;
    protected name!: string;
    protected image: string = '';
    protected productUrl: string;

    constructor() {
        super();
        this.quantity = 1;
        this.spinner = new Spinner({ scale: 0.5, left: '90%', color: '#fff' });

        this.showPrice = this.$attrs['data-show-price'] === 'True' ? true : false;
        this.price = this.$attrs['data-price'];
        this.deliveryInfo = this.$attrs['data-delivery-info'];
        this.description = this.$attrs['data-description'];
        this.articleNumber = this.$attrs['data-article-number'];
        this.rowSystemId = this.$attrs['data-row-system-id'];
        this.cssClass = this.$attrs['data-css-class'];
        this.redirectUrl = this.$attrs['data-redirect-url'];
        this.showQuantityField = this.$attrs['data-show-quantity-field'] === 'True' ? true : false;
        this.name = this.$attrs['data-name'];
        this.image = htmlDecode(this.$attrs['data-html-image']);
        this.$attrs['data-html-image'] = '';
        this.productUrl = this.$attrs['data-article-url'];
    }

    public addToCart(): void {
        this.spinner.spin(this.$el.querySelector('.buy-button') as HTMLElement);
        //console.log('Spinner start');
        const payload: AddOrUpdateCartItem = {
            articleNumber: this.articleNumber,
            quantity: this.quantity,
            rowSystemId: this.rowSystemId,
            comment: '',
            type: ''
        };

        const header = <HTMLElement>document.querySelector('#header-navigation');

        if (header && !header.classList.contains('show')) {
            const classList = header.classList;
            if (classList.contains('hide')) {
                classList.remove('hide');
            }
            if (classList.contains('bright')) {
                classList.remove('bright');
            }
            if (classList.contains('dark')) {
                classList.remove('dark');
            }
            if (!classList.contains('show')) {
                classList.add('show');
            }
            if (!classList.contains('backdrop')) {
                classList.add('backdrop');
            }
        }

        CheckoutStore.addState(payload).then(() => {
            // this.quantity = 1;
            this.spinner.stop();
            //console.log('Spinner stop');
        });

        if (this.redirectUrl !== '') {
            window.location.href = this.redirectUrl;
        }
    }

    public decrease() {
        if (this.quantity > 1) {
            this.quantity -= 1;
        } else {
            this.quantity = 1;
        }
    }

    public increase(): void {
        this.quantity += 1;
    }
}
